import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationAffiliatePatch = {
    path: "/affiliate",
    method: ERouteHttpVerb.PATCH
};
export { routeLocationAffiliatePatch };
